import * as React from "react";
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
import { LeaguePrizesGift } from "./LeaguePrizesGift";
import { LeaguePrizesStars } from "./LeaguePrizesStars";
export var LeaguePrizes = function (_a) {
    var league = _a.league, leagueId = _a.leagueId, leagueType = _a.leagueType, stars = _a.stars, highlightedLeagueId = _a.highlightedLeagueId;
    var className = "league-prizes";
    var leagueLevel = league.startsFrom + (stars - 1);
    var leagueBackground = highlightedLeagueId === leagueLevel
        ? league.idSelectedBackgroundStyle
        : league.idBackgroundStyle;
    var itemClassName = leagueBackground + " " + className + " " + className + "__container-league-prize flex";
    var medalContainerClassName = IdStyles.LeagueMedalContainer + " flex flex--guts " + className + "__center-elements";
    var icon = league.idMedalIcon.get(leagueType) || "";
    return (React.createElement("div", { className: itemClassName },
        React.createElement("div", { className: medalContainerClassName },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge })),
        React.createElement("div", { className: className + "__name-container flex--guts" },
            React.createElement(TextLoca, { id: league.idNameLoca, className: IdStyles.TextButtonDefault }),
            React.createElement(LeaguePrizesStars, { stars: stars })),
        React.createElement("div", { className: className + "__child flex--guts" },
            React.createElement(LeaguePrizesGift, { leagueId: leagueId, IdLeagueGift: IdLeagueGifts.LeagueFreeGift, leagueType: leagueType })),
        React.createElement("div", { className: className + "__child flex--guts" },
            React.createElement(LeaguePrizesGift, { leagueId: leagueId, IdLeagueGift: IdLeagueGifts.LeagueGoldGift, leagueType: leagueType })),
        React.createElement("div", { className: className + "__child flex--guts" },
            React.createElement(LeaguePrizesGift, { leagueId: leagueId, IdLeagueGift: IdLeagueGifts.LeaguePremiumOffer, leagueType: leagueType }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeaguePrizes.tsx
// module id = 2788
// module chunks = 3